module.exports = __webpack_public_path__ + "img/logo_okezone.65108b0e.png";